
  $(document).ready(function(){
    $('.inner-logo').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      draggable: true,
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '12%',
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '25%'
          }
        }
      ]
    });
  });

